import angular from 'angular';

export const defaultOptions = {
    onClose: () => {},
    cancelButtonClass: 'default-button',
    cancelLabelKey: 'CANCEL',
};

export function ModalDialogService() {
    let registeredPlaceholder = null;

    const showDialog = (dialogOptions = {}) => {
        if (registeredPlaceholder) {
            registeredPlaceholder.addDialog({ ...defaultOptions, ...dialogOptions });
        } else {
            throw new Error('Need to be registered a placeholder');
        }
    };

    const registerPlaceholder = (placeholder) => {
        if (!registeredPlaceholder) {
            registeredPlaceholder = placeholder;
        } else {
            throw new Error('Placeholder already registered');
        }
    };

    return {
        showDialog,
        registerPlaceholder,
    };
}

angular.module('TALENYA-FE').factory('ModalDialogService', ModalDialogService);
